<ng-container *ifScreenSize="screenType.Mobile">
  <ng-container *ngIf="isHomePage; else pageHeader">
    <ng-container *ngIf="memberCard$ | async as memberCard; else loadingRef">
      <div
        class="mobile-page-header container py-3"
        [style.height.px]="height"
        [ngClass]="{ 'show-after': showAfter, 'bg-corporate-primary': isCorporate, 'bg-primary': !isCorporate }"
      >
        <div class="d-flex flex-column h-100 border-disabled rounded gap-3">
          <div class="d-flex justify-content-between">
            <ng-container *ngIf="memberDetails$ | async as memberDetails">
              <!--Name and ID-->
              <div class="card-id text-start">
                <h5 class="mb-1 mb-lg-1 font-size-18 card-name text-white">
                  {{ memberDetails.FirstName }} {{ memberDetails.Surname }}
                </h5>
                <div class="d-flex mb-0 mb-lg-2 card-name-info text-white">
                  <div class="d-flex font-size-12">
                    <div *notInPopulation="[populations.JuniorBluebirds]">{{ 'member.card.product.code' | translate }}</div>
                    <div *inPopulation="[populations.JuniorBluebirds]">{{ 'member.card.product.code.kid' | translate }}</div>
                    <div class="px-2">|</div>
                    <div>ID: {{ memberDetails.MemberId }}</div>
                  </div>
                </div>
              </div>
            </ng-container>
            <button class="btn d-flex btn-redirect-wallet bg-glass" [routerLink]="'/rewards/wallet'">
              <div class="icon material-symbols-outlined">qr_code_scanner</div>
              <div class="text-white">{{ 'navbar.rewards.history' | translate }}</div>
            </button>
          </div>

          <!-- points -->
          <div *notInPopulation="[populations.JuniorBluebirds]" class="d-flex justify-content-between align-items-center">
            <div class="d-flex points-item w-100 justify-content-between bg-glass">
              <label class="mb-0 font-size-12 fw-normal">{{ 'member.card.points.balance' | translate }}</label>
              <div class="d-flex align-items-center">
                <span class="material-symbols-outlined me-3">loyalty</span>
                <div class="font-size-18 font-heading">
                  {{ pointsBalance$ | async | number: '1.0-0' : 'en-US' }}
                </div>
              </div>
            </div>
          </div>

          <!-- Homepage Kids Banner -->
          <ng-container *inPopulation="[populations.JuniorBluebirds]">
            <div class="homepage-kids-banner-div w-100 py-2">
              <img [src]="'banners/kids-home-banner.jpg' | contentAssetImage" alt="" />
            </div>
          </ng-container>

          <!-- navigation -->
          <ng-container>
            <div
              #nav
              class="mobile-navigation d-flex flex-row align-items-center pb-2 mb-2"
              [ngClass]="{ 'corporate-mobile-navigation': isCorporate }"
              [class.at-end]="atRightEnd"
              (scroll)="onNavScroll()"
            >
              <div class="navigation" routerLink="/rewards">
                <span class="icons material-symbols-outlined bg-glass mb-1"> redeem </span>
                <a class="text-white font-size-14">{{ 'member.card.rewards' | translate }}</a>
              </div>

              <div class="navigation" routerLink="/challenges">
                <span class="icons material-symbols-outlined bg-glass mb-1"> emoji_events </span>
                <a class="text-white font-size-14">{{ 'member.card.challenges' | translate }}</a>
              </div>

              <div class="navigation" routerLink="/games">
                <span class="icons material-symbols-outlined bg-glass mb-1"> stadia_controller </span>
                <a class="text-white font-size-14">{{ 'member.card.games' | translate }}</a>
              </div>

              <div *notInPopulation="[populations.JuniorBluebirds]" class="navigation" routerLink="/earn">
                <span class="icons material-symbols-outlined bg-glass mb-1"> money </span>
                <a class="text-white font-size-14">{{ 'member.card.earn' | translate }}</a>
              </div>

              <div class="navigation" routerLink="/gallery">
                <span class="icons material-symbols-outlined bg-glass mb-1"> animated_images </span>
                <a class="text-white font-size-14">{{ 'member.card.gallery' | translate }}</a>
              </div>

              <div *inPopulation="[populations.JuniorBluebirds]" class="navigation" routerLink="/worksheet">
                <span class="icons material-symbols-outlined bg-glass mb-1"> tactic </span>
                <a class="text-white font-size-14">{{ 'member.card.activities' | translate }}</a>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>

    <ng-template #loadingRef>
      <fgb-loading></fgb-loading>
    </ng-template>
  </ng-container>

  <ng-template #pageHeader>
    <div
      class="page-header"
      [ngClass]="{ 'hide-footer': !showFooter, 'bg-corporate-primary': isCorporate, 'bg-primary': !isCorporate }"
    >
      <div class="container">
        <div class="d-flex flex-column">
          <div class="d-flex align-items-center text-white">
            <div class="banner-name">
              <a (click)="goBack()" class="btn back-btn text-white px-0">
                <span class="icon material-icons" aria-hidden="true">arrow_back_ios</span>
              </a>
              <h4 class="font-size-20 mb-0" [ngClass]="{ 'text-title-center': !showBalance }">
                {{ pageTitle | translate | uppercase }}
              </h4>
            </div>
            <div *ngIf="showBalance" class="ms-auto d-flex align-items-center widget-details">
              <div *ngIf="!isJuniorBluebird" class="balance-details d-flex bg-glass-dark align-items-center">
                <span class="icons material-icons"> loyalty </span>
                <div class="balance">
                  <p class="mb-0 font-size-14 fw-bold">{{ pointsBalance$ | async | number: '1.0-0' : 'en-GB' }}</p>
                </div>
              </div>

              <button *ngIf="showQr" class="qrcode-btn text-white bg-glass-dark" [routerLink]="'/rewards/wallet'">
                <span class="icon material-symbols-outlined material-mobile-nav">qr_code</span>
              </button>
            </div>
          </div>
          <ng-container *ngIf="isImageBanner">
            <div class="w-100 bg-primary">
              <img class="mt-2 mb-3 image-banner w-100" [src]="imageBannerUrl | contentAssetImage" alt="" />
            </div>
          </ng-container>
        </div>
        <div class="footer"></div>
      </div>
    </div>
  </ng-template>
</ng-container>
